import React, { useState } from "react";
import { useModules } from "../context/ModulesContext";

interface DefaultModuleModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (selectedModule: string) => void;
  enabledModules: string[];
}

export default function DefaultModuleModal({
  isOpen,
  onClose,
  onConfirm,
  enabledModules,
}: DefaultModuleModalProps) {
  const { approvedKeys, labelFor } = useModules();
  const [selected, setSelected] = useState<string>("");

  if (!isOpen) return null;

  const options = approvedKeys.filter(
    (k) => k !== "chatbot" && enabledModules.includes(k),
  );

  return (
    <div className="smrtdocs-modal-overlay">
      <div className="smrtdocs-modal" style={{ width: "480px" }}>
        <div className="smrtdocs-modal-header">
          <h2 style={{ margin: 0, fontSize: "1rem" }}>
            You must select a default module landing page
          </h2>
        </div>
        <div className="smrtdocs-modal-body">
          <p style={{ fontSize: "0.9rem", lineHeight: 1.5, margin: "0 0 16px" }}>
            Disabling Chatbot removes the default landing page. Select a
            replacement module that users will see after login.
          </p>

          {options.length === 0 ? (
            <p style={{ fontSize: "0.85rem", color: "#ef9a9a", margin: "0 0 20px" }}>
              No other modules are enabled. Enable at least one module before
              disabling Chatbot.
            </p>
          ) : (
            <div style={{ margin: "0 0 20px", display: "flex", flexDirection: "column", gap: "8px" }}>
              {options.map((key) => (
                <label
                  key={key}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    padding: "8px 12px",
                    borderRadius: "6px",
                    cursor: "pointer",
                    background: selected === key ? "rgba(255,255,255,0.1)" : "transparent",
                    transition: "background 0.15s",
                  }}
                >
                  <input
                    type="radio"
                    name="defaultModule"
                    value={key}
                    checked={selected === key}
                    onChange={() => setSelected(key)}
                  />
                  <span style={{ fontSize: "0.9rem" }}>{labelFor(key)}</span>
                </label>
              ))}
            </div>
          )}

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <button className="btn-cancel" onClick={onClose}>
              Cancel
            </button>
            <button
              className="btn-save"
              style={{
                background: "#c62828",
                borderColor: "#c62828",
                opacity: !selected ? 0.5 : 1,
                cursor: !selected ? "not-allowed" : "pointer",
              }}
              disabled={!selected}
              onClick={() => {
                onConfirm(selected);
                setSelected("");
              }}
            >
              Disable Chatbot
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
